import { create } from 'zustand';

interface RoentgenState {
  /** Whether the Roentgen drawer is open */
  drawerOpen: boolean;
  /** Currently active chat session ID */
  activeSessionId: string | null;
  /** Whether assistant-proposed UI actions may mutate PACS UI state */
  allowUiActions: boolean;

  toggle: () => void;
  open: () => void;
  close: () => void;
  setActiveSession: (id: string | null) => void;
  setAllowUiActions: (allow: boolean) => void;
}

export const useRoentgenStore = create<RoentgenState>((set) => ({
  drawerOpen: false,
  activeSessionId: null,
  allowUiActions: false,

  toggle: () => set((s) => ({ drawerOpen: !s.drawerOpen })),
  open: () => set({ drawerOpen: true }),
  close: () => set({ drawerOpen: false }),
  setActiveSession: (id) => set({ activeSessionId: id }),
  setAllowUiActions: (allow) => set({ allowUiActions: allow }),
}));
